
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonBasicModule } from '../../Common/Basic/basic.module';
import { LocalizationModule } from '../../Core/Localization/localization.module';
import { ClickOutsideModule } from 'ng-click-outside';
import { SystemsNotificationsComponent } from './components/SystemNotifications/systems-notifications.component';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { CommonFormsModule } from '../../Common/Forms/forms.module';
import { SystemsNotificationsCreateDialogComponent } from './components/SystemsNotificationsCreateDialog/systems-notifications-create-dialog.component';
import { CoreDialogsModule } from '../../Core/Dialogs/dialogs.module';
import { LayoutModule } from '../../Common/Layout/layout.module';
import { MonitorSharedModule } from '../../Monitor/Shared/monitoring-shared.module';
import { MiscModule } from '../../Common/Misc/misc.module';
import { SystemNotificationService } from './services/system-notification.service';
import { SystemNotificationApi } from '../../api/systemNotifications/system-notification.api';
import { SystemsNotificationsCardComponent } from './components/SystemsNotificationsCard/systems-notifications-card.component';
import { FilterModule } from '../../Common/Filter/filter.module';
import { TooltipModule } from 'primeng/tooltip';
import { MentionsModule } from '../../Common/Mentions/mentions.module';


@NgModule({
    imports: [
        /* Angular */
        CommonModule,
        FormsModule,
        ClickOutsideModule,

        /* Primeng */

        ButtonModule,
        CheckboxModule,
        TooltipModule,

        /* Common, Core, Shared Monitor */
        CommonBasicModule,
        LocalizationModule,
        CommonFormsModule,
        CoreDialogsModule,
        LayoutModule,
        MonitorSharedModule,
        MiscModule,
        FilterModule,
        MentionsModule
    ],
    declarations: [
        SystemsNotificationsComponent,
        SystemsNotificationsCreateDialogComponent,
        SystemsNotificationsCardComponent
    ],
    exports: [
        SystemsNotificationsComponent
    ],
    providers: [
        // Api and Services
        SystemNotificationApi,
        SystemNotificationService
    ],
})
export class SystemNotificationsModule {}
